import * as React from "react";
import { SVGProps } from "react";
const SvgComprehensiveWealth = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={24} height={24} rx={4} fill="#095921" />
    <path
      d="M18 12a6 6 0 0 1-6 6m6-6a6 6 0 0 0-6-6m6 6H6m6 6a6 6 0 0 1-6-6m6 6c1.105 0 2-2.686 2-6s-.895-6-2-6m0 12c-1.105 0-2-2.686-2-6s.895-6 2-6m-6 6a6 6 0 0 1 6-6"
      stroke="#fff"
      strokeWidth={1.13}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgComprehensiveWealth;
